import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { hideModalDialog } from '../ModalDialog';
import { Comment } from './Comment';
import { removeCommentAction, getCommentsAction } from './CommentsActions';
import { getDictionaryByName } from '../Dictionary';
export class CommentsForm extends Component {
    static propTypes = {
        documentId: PropTypes.string,
        comments: PropTypes.array,
        handleChangeComents: PropTypes.func.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            comments: this.props.comments ? this.props.comments : [],
            statuses: []
        };
        this.deleteComent = this.deleteComent.bind(this);
        this.handleChangeComents = this.handleChangeComents.bind(this);
        this.handleChangeComent = this.handleChangeComent.bind(this);
    }
    componentDidMount() {
        const { documentId } = this.props;
        const object = this;
        getDictionaryByName("InitiatorSystem").then((data) => {
            this.setState({
                statuses: data
            });
        });
        if (documentId) {
            getCommentsAction(documentId).then((data) => {
                object.props.handleChangeComents(data);
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.comments !== this.props.comments) {
            this.setState({
                comments: this.props.comments
            });
        }
    }
    render() {
        const { documentId } = this.props;
        const { comments, statuses } = this.state;
        return (<div className="form-block large-form doc-form">
            <div className="form-content">
                <div className="comments">
                    {comments.map((item) =>
                        <Comment key={item.id} nesting={1} statuses={statuses} handleChangeComents={this.handleChangeComents} handleChangeComent={this.handleChangeComent} documentId={documentId} handleDeliteComent={() => this.deleteComent(item)} comment={item} />
                    )}
                </div>
            </div>
        </div>);
    }
    async deleteComent(coment) {
        const { documentId } = this.props;
        if (documentId) {
            const data = await removeCommentAction(coment, documentId);
            if (data) {
                this.setState({
                    comments: data
                });
                this.handleChangeComents(data);
            }
        }
        else {
            let index = this.state.comments.indexOf(coment);
            if (index !== -1) {
                this.state.comments.splice(index, 1);
                this.setState({ comments: this.state.comments });
            }
            this.handleChangeComents(this.state.comments);
        }
        hideModalDialog('modalDialog');
    }
    handleChangeComents(commets) {
        if (commets) {
            this.setState({ comments: [] });
            this.setState({ comments: commets });
        }
        else {
            commets = this.state.comments;
        }
        this.props.handleChangeComents(commets);
    }
    handleChangeComent(comnet) {
        const { comments } = this.state;
        const index = comments.findIndex((item) => item.id === comnet.id);
        if (index !== -1) comments[index] = comnet;
        this.setState({
            comments: this.state.comments
        });
        this.handleChangeComents(comments);
    }
}
